import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal /*openModal*/ } from '../../../redux/actions/modals';
// import { useHistory } from 'react-router-dom';
// import CameraIcon from '../UI/SvgsIcons/CameraIcon';
import DownArrowIcon from '../../UI/SvgsIcons/DownArrowIcon';
import classes from './CustomersPhotosModal.module.css';

const CustomersPhotosModal = () => {
	const {
		moverData: {
			name,
			mover_show_data: { move_images },
		},
	} = useSelector(state => state.modals[0].properties.values);
	const isMobile = useSelector(state => state.ui.mobile.isMobile);
	// const isLoggedIn = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();
	// const history = useHistory();
	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const currentImage = move_images[currentImageIndex];

	// const addPhotoHandler = () => {
	//   if (isLoggedIn) {
	//     history.push({
	//       pathname: 'addPhotos/',
	//       state: {
	//         moverData: moverData,
	//         from: history.location.pathname,
	//       },
	//     });
	//   } else {
	//     dispatch(openModal({ name: 'authModal', properties: { authModalView: 'login' } }));
	//   }
	// };

	const goToPreviousImage = () => {
		if (currentImageIndex !== 0)
			setCurrentImageIndex(prevState => prevState - 1);
	};

	const goToNextImage = () => {
		if (currentImageIndex !== move_images.length - 1)
			setCurrentImageIndex(prevState => prevState + 1);
	};

	return (
		<div className="modal-content modal-xl w-100">
			<header className="modal-header top-action-panel p-0">
				<button
					aria-label="Close"
					className="close-reveal-modal anchor-button"
					onClick={() => dispatch(closeModal())}>
					✖
				</button>
			</header>
			<div className="modal-body">
				{!isMobile ? (
					<div>
						<header className="w-100 mb-3">
							<div className="d-flex w-100 align-items-center">
								<h3 className="font-weight-bold mb-0">Photos for {name}</h3>
								{/* <button className={`ml-auto btnAddPhoto`} onClick={addPhotoHandler}>
                <span className="mr-2">
                  <CameraIcon width="30" height="25" />
                </span>
                Add Photos
              </button> */}
							</div>
						</header>
						<div className={`w-100 h-100 ${classes.gallery}`}>
							{move_images.length > 0 &&
								move_images.map((photo, index) => (
									<div
										key={index}
										className={`position-relative ${classes.imageContainer} mb-2`}>
										<LazyLoadImage
											className="rounded"
											src={photo.src}
											alt=""
											height={200}
											width={200}
											style={{ objectFit: 'cover' }}
										/>
										{photo.caption && (
											<span
												className={`position-absolute rounded ${classes.caption}`}>
												{photo.caption}
											</span>
										)}
									</div>
								))}
						</div>
					</div>
				) : (
					<div>
						<div className={`position-relative ${classes.imageContainer}`}>
							<div className="w-100 d-flex justify-content-between align-items-center mb-3">
								<div
									className={classes.previousIconContainer}
									role="button"
									onClick={goToPreviousImage}>
									<DownArrowIcon fill={'#9AA0A6'} />
								</div>
								<div>
									<p className="mb-0">
										{currentImageIndex + 1}/{move_images.length}
									</p>
								</div>
								<div
									className={classes.nextIconContainer}
									role="button"
									onClick={goToNextImage}>
									<DownArrowIcon fill={'#9AA0A6'} />
								</div>
							</div>
							<LazyLoadImage
								className="rounded"
								src={currentImage.src}
								alt={currentImage.caption ?? ''}
								height="100%"
								width="100%"
								style={{ objectFit: 'cover' }}
							/>
							{currentImage.caption && (
								<span
									className={`position-absolute rounded ${classes.caption}`}>
									{currentImage.caption}
								</span>
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default CustomersPhotosModal;
